import { Badge } from "@/components/ui/badge";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { Brain } from "lucide-react";
import ReactMarkdown from "react-markdown";

import { WebsiteAuditSection } from "./WebsiteAuditSection";
import { PresenceAuditSection } from "./PresenceAuditSection";
import { SearchRankingsSection } from "./SearchRankingsSection";
import { CrmHistorySection } from "./CrmHistorySection";

export function AuditSections({
  company, latestAudit, wChecks, pChecks, fails, warns, passes,
  foundP, inaccP, missingP, unknownP, catGroups, gbpFound, searchRankings,
  gbpSaving, confirmGbp, clearGbp, setGbpUrl, setGbpOpen,
}) {
  return (
    <Accordion type="multiple" defaultValue={["ai-analysis"]} className="space-y-2">

      {/* AI Analysis */}
      {latestAudit?.ai_report?.ai_summary && (
        <AccordionItem value="ai-analysis" className="border border-slate-200 rounded-lg shadow-sm overflow-hidden">
          <AccordionTrigger className="px-4 py-3 hover:no-underline hover:bg-slate-50 [&[data-state=open]]:bg-slate-50">
            <div className="flex items-center gap-2">
              <Brain className="w-4 h-4 text-indigo-600" />
              <span className="text-sm font-semibold" style={{ fontFamily: 'Manrope, sans-serif' }}>AI Analysis</span>
              {latestAudit.ai_report.generated && <Badge className="text-[8px] bg-indigo-100 text-indigo-600 border-indigo-200 h-3.5" variant="outline">Gemini</Badge>}
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-4">
            <div className="prose prose-sm max-w-none text-slate-700 [&_h2]:text-sm [&_h2]:font-semibold [&_h2]:mt-3 [&_h2]:mb-1 [&_h3]:text-[13px] [&_h3]:font-semibold [&_h3]:mt-2 [&_h3]:mb-1 [&_p]:text-[12px] [&_p]:leading-relaxed [&_p]:mb-1.5 [&_li]:text-[12px] [&_strong]:text-slate-900 [&_ul]:my-0.5">
              <ReactMarkdown>{latestAudit.ai_report.ai_summary}</ReactMarkdown>
            </div>
          </AccordionContent>
        </AccordionItem>
      )}

      <WebsiteAuditSection company={company} wChecks={wChecks} catGroups={catGroups} fails={fails} warns={warns} passes={passes} />

      <PresenceAuditSection
        company={company} pChecks={pChecks} foundP={foundP} inaccP={inaccP} missingP={missingP} unknownP={unknownP}
        gbpFound={gbpFound} gbpSaving={gbpSaving} confirmGbp={confirmGbp} clearGbp={clearGbp}
        setGbpUrl={setGbpUrl} setGbpOpen={setGbpOpen} />

      <SearchRankingsSection searchRankings={searchRankings} />

      <CrmHistorySection company={company} />

    </Accordion>
  );
}
